var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-modal-contents", {
        ref: "modal_contents_agree",
        scopedSlots: _vm._u([
          {
            key: "close",
            fn: function () {
              return [_c("div")]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use__title" }, [
                  _c("div", { staticClass: "h2_title" }, [
                    _vm._v("Условия использования персональных данных"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use mt-30 " }, [
                  _c("div", { domProps: { innerHTML: _vm._s(_vm.terms) } }),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-30" }, [
                    _c(
                      "button",
                      {
                        staticClass: "px-30 btn_bordered ",
                        on: {
                          click: function ($event) {
                            return _vm.$refs.modal_contents_agree.modal_open()
                          },
                        },
                      },
                      [_vm._v("\n            Прочитал\n          ")]
                    ),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "v-form",
        {
          ref: "form",
          staticClass: "formNew_wrap",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c(
            "div",
            { staticClass: "row mx-0 my-0" },
            [
              _vm._t("description", function () {
                return [
                  _c("div", { staticClass: "col-12 col-md-6 col-lg-6 p-md-2" }),
                ]
              }),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-md-6 col-lg" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-12 pb-3 px-3 pt-3" },
                    [
                      _c(
                        "div",
                        { staticClass: "formNew_wrap__item" },
                        [
                          _c("v-text-field", {
                            staticClass: "form__input",
                            attrs: {
                              rules: [
                                _vm.rules.required,
                                _vm.rules.ruleTownName,
                              ],
                              required: "",
                              id: "name",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      "\n                  ФИО *\n                "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.name,
                              callback: function ($$v) {
                                _vm.name = $$v
                              },
                              expression: "name",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-md-6 pb-3 px-3 pt-3" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "formNew_wrap__item item_tel position-relative",
                      },
                      [
                        _c("v-text-field", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "# ### ###-##-##",
                              expression: "'# ### ###-##-##'",
                            },
                          ],
                          staticClass: "pl-0 form__input",
                          attrs: {
                            rules: _vm.tel_inputRulesRu,
                            required: "",
                            id: "tel",
                            oninput:
                              "this.value = this.value.replace(/^\\(8/, '(');",
                            max: "20",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                  Телефон *\n                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.tel_input,
                            callback: function ($$v) {
                              _vm.tel_input = $$v
                            },
                            expression: "tel_input",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-md-6 pb-3 px-3 pt-3" }, [
                    _c(
                      "div",
                      { staticClass: "formNew_wrap__item" },
                      [
                        _vm.language == "ru"
                          ? _c("v-text-field", {
                              staticClass: "form__input",
                              attrs: {
                                rules: [_vm.rules.mail],
                                required: "",
                                oninput: "this.value = this.value.trim()",
                                id: "email",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _vm._v(
                                          "\n                  Электронная почта *\n                "
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                864388351
                              ),
                              model: {
                                value: _vm.email,
                                callback: function ($$v) {
                                  _vm.email = $$v
                                },
                                expression: "email",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-md-6 pb-3 px-3 pt-3" }, [
                    _c(
                      "div",
                      { staticClass: "formNew_wrap__item" },
                      [
                        _c("v-text-field", {
                          staticClass: "form__input",
                          attrs: {
                            rules: [_vm.rules.required],
                            required: "",
                            id: "company",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                  Страна *\n                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.сountry,
                            callback: function ($$v) {
                              _vm.сountry = $$v
                            },
                            expression: "сountry",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-md-6 pb-3 px-3 pt-3" }, [
                    _c(
                      "div",
                      { staticClass: "formNew_wrap__item" },
                      [
                        _c("v-text-field", {
                          staticClass: "form__input",
                          attrs: {
                            rules: [_vm.rules.required],
                            required: "",
                            id: "company",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                  Город *\n                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.city,
                            callback: function ($$v) {
                              _vm.city = $$v
                            },
                            expression: "city",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-md-12 px-3 pt-3" }, [
                    _c("div", { staticClass: "form_upload__item " }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "summary p-12 bg-gray-100 border border-gray-300 drag_form d-flex flex-column justify-content-center",
                          attrs: { id: "summary" },
                          on: {
                            dragover: _vm.dragover,
                            dragleave: _vm.dragleave,
                            drop: _vm.drop,
                          },
                        },
                        [
                          _c("input", {
                            ref: "file",
                            staticClass:
                              "w-px h-px opacity-0 overflow-hidden absolute",
                            attrs: {
                              type: "file",
                              multiple: "",
                              name: "fields[assetsFieldHandle][]",
                              id: "assetsFieldHandle",
                              accept:
                                ".pdf,.jpg,.jpeg,.png,.rtf,.doc,.docx,.xls,.xlsx",
                            },
                            on: { change: _vm.onChange },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "block cursor-pointer",
                              attrs: { for: "assetsFieldHandle" },
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "Выберите или перетащите сюда файл в формате PDF, DOC, DOCX,\n                    RTF, JPG\n                  "
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          this.filelist.length
                            ? _c(
                                "ul",
                                { staticClass: "mt-4" },
                                _vm._l(_vm.filelist, function (file, index) {
                                  return _c(
                                    "li",
                                    {
                                      key: index,
                                      staticClass: "text-sm p-1 text-left",
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(file.name) +
                                          "\n                    "
                                      ),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "ml-2 remove_file",
                                          attrs: {
                                            type: "button",
                                            title: "Remove file",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.remove(
                                                _vm.filelist.indexOf(file)
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      Удалить\n                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-12 pb-3 px-3 pt-3" },
                    [
                      _c("div", {
                        staticClass: "w-100 mt-30",
                        class: _vm.captchaPassed ? "" : "error-captcha",
                        attrs: { id: "captcha-container" },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "formNew_wrap__item  mt-30" },
                        [
                          _c("v-checkbox", {
                            attrs: {
                              rules: [
                                function (v) {
                                  return !!v || "Это обязательный пункт"
                                },
                              ],
                              required: "",
                              color: "red",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "customLabelForm" },
                                      [
                                        _vm._v(
                                          "\n                    Я выражаю согласие с "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: "javascript:void(0);",
                                              target: "_blank",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.$refs.modal_contents_agree.modal_open(
                                                  "scroll_false"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "условиями\n                    использования"
                                            ),
                                          ]
                                        ),
                                        _vm._v(
                                          " моих персональных данных для обработки данного обращения\n                    ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206, Московская область,\n                    г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2), я ознакомлен и выражаю\n                    согласие с\n                    "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "position-relative zi-1",
                                            attrs: { href: _vm.policy },
                                            on: {
                                              click: function ($event) {
                                                return _vm.linkOpen(_vm.policy)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "Политикой\n                      конфиденциальности"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" и "),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "position-relative zi-1",
                                            attrs: { href: _vm.agreement },
                                            on: {
                                              click: function ($event) {
                                                return _vm.linkOpen(
                                                  _vm.agreement
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "Пользовательским\n                    соглашением."
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.checkbox,
                              callback: function ($$v) {
                                _vm.checkbox = $$v
                              },
                              expression: "checkbox",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-checkbox", {
                            staticClass: "mt-0",
                            attrs: { color: "red" },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "customLabelForm" },
                                      [
                                        _vm._v(
                                          "\n                    Я выражаю согласие на информирование меня о продуктах, акциях, выгодных\n                    предложениях, новостях ООО «Компания Нова Ролл» (ИНН 5038050970, адрес:\n                    141206, Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5,\n                    этаж 2) и\n                    партнеров.\n                  "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.consentToInform,
                              callback: function ($$v) {
                                _vm.consentToInform = $$v
                              },
                              expression: "consentToInform",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "btn_form d-flex align-items-center  ",
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn-red w-mc",
                                  attrs: { disabled: !_vm.valid },
                                  on: { click: _vm.sendForm },
                                },
                                [
                                  _vm._v(
                                    "\n                  Отправить\n                "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
              ]),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }